<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Alerts</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Examples</h5>
              <p>Alerts are available for any length of text, as well as an optional dismiss button. For proper styling,
                use one of the eight <strong>required</strong> contextual classes (e.g., <code
                  class="text-danger">.alert-success</code>).</p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab('1')"
                      [ngClass]="{'active': viewTab}">Custom</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('2')"
                      [ngClass]="{'active': bootTab}">Bootstrap</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('3')"
                      [ngClass]="{'active': codeTab}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-c1" [ngClass]="{'show active': viewTab}">
                      <div class="alert alert-primary custom-alert" role="alert">
                        A simple primary alert—check it out!
                      </div>
                      <div class="alert alert-secondary custom-alert" role="alert">
                        A simple secondary alert—check it out!
                      </div>
                      <div class="alert alert-success custom-alert" role="alert">
                        A simple success alert—check it out!
                      </div>
                      <div class="alert alert-danger custom-alert" role="alert">
                        A simple danger alert—check it out!
                      </div>
                      <div class="alert alert-warning custom-alert" role="alert">
                        A simple warning alert—check it out!
                      </div>
                      <div class="alert alert-info custom-alert" role="alert">
                        A simple info alert—check it out!
                      </div>
                      <div class="alert alert-light custom-alert" role="alert">
                        A simple light alert—check it out!
                      </div>
                      <div class="alert alert-dark custom-alert" role="alert">
                        A simple dark alert—check it out!
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-view-1" role="tabpanel" [ngClass]="{'show active': bootTab}">
                      <div class="alert alert-primary" role="alert">
                        A simple primary alert—check it out!
                      </div>
                      <div class="alert alert-secondary" role="alert">
                        A simple secondary alert—check it out!
                      </div>
                      <div class="alert alert-success" role="alert">
                        A simple success alert—check it out!
                      </div>
                      <div class="alert alert-danger" role="alert">
                        A simple danger alert—check it out!
                      </div>
                      <div class="alert alert-warning" role="alert">
                        A simple warning alert—check it out!
                      </div>
                      <div class="alert alert-info" role="alert">
                        A simple info alert—check it out!
                      </div>
                      <div class="alert alert-light" role="alert">
                        A simple light alert—check it out!
                      </div>
                      <div class="alert alert-dark" role="alert">
                        A simple dark alert—check it out!
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-1" role="tabpanel" [ngClass]="{'show active': codeTab}">
                      <pre><code class="language-html">&lt;div class=&quot;alert alert-primary&quot; role=&quot;alert&quot;&gt;
          A simple primary alert&mdash;check it out!
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-secondary&quot; role=&quot;alert&quot;&gt;
          A simple secondary alert&mdash;check it out!
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-success&quot; role=&quot;alert&quot;&gt;
          A simple success alert&mdash;check it out!
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-danger&quot; role=&quot;alert&quot;&gt;
          A simple danger alert&mdash;check it out!
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-warning&quot; role=&quot;alert&quot;&gt;
          A simple warning alert&mdash;check it out!
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-info&quot; role=&quot;alert&quot;&gt;
          A simple info alert&mdash;check it out!
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-light&quot; role=&quot;alert&quot;&gt;
          A simple light alert&mdash;check it out!
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-dark&quot; role=&quot;alert&quot;&gt;
          A simple dark alert&mdash;check it out!
      &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Link color</h5>
              <p>Use the <code class="text-danger">.alert-link</code> utility class to quickly provide matching colored
                links within any alert.</p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab1('1')"
                      [ngClass]="{'active': viewTab1}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab1('2')"
                      [ngClass]="{'active': codeTab1}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-2" [ngClass]="{'show active': viewTab1}">
                      <div class="alert alert-primary" role="alert">
                        A simple primary alert with <a href="#" class="alert-link">an example link</a>. Give it a click
                        if
                        you like.
                      </div>
                      <div class="alert alert-secondary" role="alert">
                        A simple secondary alert with <a href="#" class="alert-link">an example link</a>. Give it a
                        click
                        if you like.
                      </div>
                      <div class="alert alert-success" role="alert">
                        A simple success alert with <a href="#" class="alert-link">an example link</a>. Give it a click
                        if
                        you like.
                      </div>
                      <div class="alert alert-danger" role="alert">
                        A simple danger alert with <a href="#" class="alert-link">an example link</a>. Give it a click
                        if
                        you like.
                      </div>
                      <div class="alert alert-warning" role="alert">
                        A simple warning alert with <a href="#" class="alert-link">an example link</a>. Give it a click
                        if
                        you like.
                      </div>
                      <div class="alert alert-info" role="alert">
                        A simple info alert with <a href="#" class="alert-link">an example link</a>. Give it a click if
                        you like.
                      </div>
                      <div class="alert alert-light" role="alert">
                        A simple light alert with <a href="#" class="alert-link">an example link</a>. Give it a click if
                        you like.
                      </div>
                      <div class="alert alert-dark" role="alert">
                        A simple dark alert with <a href="#" class="alert-link">an example link</a>. Give it a click if
                        you like.
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-2" [ngClass]="{'show active': codeTab1}">
                      <pre><code class="language-html">&lt;div class=&quot;alert alert-primary&quot; role=&quot;alert&quot;&gt;
          A simple primary alert with &lt;a href=&quot;#&quot; class=&quot;alert-link&quot;&gt;an example link&lt;/a&gt;. Give it a click if you like.
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-secondary&quot; role=&quot;alert&quot;&gt;
          A simple secondary alert with &lt;a href=&quot;#&quot; class=&quot;alert-link&quot;&gt;an example link&lt;/a&gt;. Give it a click if you like.
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-success&quot; role=&quot;alert&quot;&gt;
          A simple success alert with &lt;a href=&quot;#&quot; class=&quot;alert-link&quot;&gt;an example link&lt;/a&gt;. Give it a click if you like.
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-danger&quot; role=&quot;alert&quot;&gt;
          A simple danger alert with &lt;a href=&quot;#&quot; class=&quot;alert-link&quot;&gt;an example link&lt;/a&gt;. Give it a click if you like.
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-warning&quot; role=&quot;alert&quot;&gt;
          A simple warning alert with &lt;a href=&quot;#&quot; class=&quot;alert-link&quot;&gt;an example link&lt;/a&gt;. Give it a click if you like.
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-info&quot; role=&quot;alert&quot;&gt;
          A simple info alert with &lt;a href=&quot;#&quot; class=&quot;alert-link&quot;&gt;an example link&lt;/a&gt;. Give it a click if you like.
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-light&quot; role=&quot;alert&quot;&gt;
          A simple light alert with &lt;a href=&quot;#&quot; class=&quot;alert-link&quot;&gt;an example link&lt;/a&gt;. Give it a click if you like.
      &lt;/div&gt;
      &lt;div class=&quot;alert alert-dark&quot; role=&quot;alert&quot;&gt;
          A simple dark alert with &lt;a href=&quot;#&quot; class=&quot;alert-link&quot;&gt;an example link&lt;/a&gt;. Give it a click if you like.
      &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Additional content</h5>
              <p>Alerts can also contain additional HTML elements like headings, paragraphs and dividers.</p>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab2('1')"
                      [ngClass]="{'active': viewTab2}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab2('2')"
                      [ngClass]="{'active': codeTab2}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-3" [ngClass]="{'show active': viewTab2}">
                      <div class="alert alert-success" role="alert">
                        <h4 class="alert-heading">Well done!</h4>
                        <p>Aww yeah, you successfully read this important alert message. This example text is going to
                          run
                          a bit longer so that you can see how spacing within an alert works with this kind of content.
                        </p>
                        <hr>
                        <p class="mb-0">Whenever you need to, be sure to use margin utilities to keep things nice and
                          tidy.</p>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-3" [ngClass]="{'show active': codeTab2}">
                      <pre><code class="language-html">&lt;div class=&quot;alert alert-success&quot; role=&quot;alert&quot;&gt;
          &lt;h4 class=&quot;alert-heading&quot;&gt;Well done!&lt;/h4&gt;
          &lt;p&gt;Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.&lt;/p&gt;
          &lt;hr&gt;
          &lt;p class=&quot;mb-0&quot;&gt;Whenever you need to, be sure to use margin utilities to keep things nice and tidy.&lt;/p&gt;
      &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Dismissing</h5>
              <p>Using the alert JavaScript plugin, it’s possible to dismiss any alert inline. Here’s how:</p>
              <ul>
                <li>Be sure you’ve loaded the alert plugin, or the compiled Bootstrap JavaScript.</li>
                <li>If you’re building our JavaScript from source, it <a href="#">requires <code
                      class="text-danger">util.js</code></a>. The compiled version includes this.</li>
                <li>Add a dismiss button and the <code class="text-danger">.alert-dismissible</code> class, which adds
                  extra padding to the right of the alert and positions the <code class="text-danger">.close</code>
                  button.</li>
                <li>On the dismiss button, add the <code class="text-danger">data-dismiss="alert"</code> attribute,
                  which
                  triggers the JavaScript functionality. Be sure to use the <code
                    class="text-danger">&lt;button&gt;</code> element with it for proper behavior across all devices.
                </li>
                <li>To animate alerts when dismissing them, be sure to add the <code class="text-danger">.fade</code>
                  and
                  <code class="text-danger">.show</code> classes.
                </li>
              </ul>
              <div class="card mb-5 shadow-sm">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item"><a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab3('1')"
                      [ngClass]="{'active': viewTab3}">View</a></li>
                  <li class="nav-item"><a class="nav-link" href="javascript:void(0)" (click)="onMenuTab3('2')"
                      [ngClass]="{'active': codeTab3}">Code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="tab-view-4" [ngClass]="{'show active': viewTab3}">
                      <div class="alert alert-warning alert-dismissible fade show" role="alert">
                        <strong>Holy guacamole!</strong> You should check in on some of those fields below.
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="tab-code-4" [ngClass]="{'show active': codeTab3}">
                      <pre><code class="language-html">&lt;div class=&quot;alert alert-warning alert-dismissible fade show&quot; role=&quot;alert&quot;&gt;
          &lt;strong&gt;Holy guacamole!&lt;/strong&gt; You should check in on some of those fields below.
          &lt;button type=&quot;button&quot; class=&quot;close&quot; data-dismiss=&quot;alert&quot; aria-label=&quot;Close&quot;&gt;
              &lt;span aria-hidden=&quot;true&quot;&gt;&amp;times;&lt;/span&gt;
          &lt;/button&gt;
      &lt;/div&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
